// The one primary action per order. Renders from order.next_action (server
// computed) and never decides anything itself. Disabled → the reason shows
// as a tooltip (desktop) and as a second line (size 'lg', touch).
import React from 'react';
import { useOrderActions } from './OrderActionContext';

const VARIANT = {
  primary: { bg: 'linear-gradient(135deg,#f97316,#ea580c)', color: '#fff' },
  danger:  { bg: '#7f1d1d', color: '#fecaca' },
  warn:    { bg: '#4c1d95', color: '#e9d5ff' },
};
const SIZE = {
  sm: { padding: '5px 12px', fontSize: 11 },
  md: { padding: '8px 16px', fontSize: 12 },
  lg: { padding: '13px 18px', fontSize: 15 },
};

// onBlocked(next_action): a disabled reason the caller can act on (today: "Add at least one item" → the
// order form with the equipment picker open). The button then reads as a hint, not a dead end.
export default function NextStepButton({ order, size = 'md', fullWidth = false, style = {}, onDone, onBlocked }) {
  const actions = useOrderActions();
  const na = order?.next_action;
  if (!na || !na.action) return null;
  const v = VARIANT[na.variant] || VARIANT.primary;
  const s = SIZE[size] || SIZE.md;
  const disabled = !na.enabled;
  const actionable = disabled && !!onBlocked && na.reason === 'Add at least one item';
  return (
    <button
      type="button"
      data-testid="next-step"
      data-action={na.action}
      data-order-id={order.id}
      data-blocked-action={actionable ? 'add-items' : undefined}
      disabled={disabled && !actionable}
      title={disabled ? na.reason : (na.effects || []).join('\n')}
      aria-label={na.label}
      onClick={(e) => { e.stopPropagation(); if (!disabled) actions.openAction(order, na.action); else if (actionable) onBlocked(na); }}
      style={{
        ...s, width: fullWidth ? '100%' : undefined, whiteSpace: 'nowrap',
        background: disabled ? '#1e2235' : v.bg, color: disabled ? (actionable ? '#fbbf24' : '#64748b') : v.color,
        border: disabled ? `1px solid ${actionable ? '#92400e' : '#2a2d3e'}` : 'none', borderRadius: 7, fontWeight: 800, letterSpacing: 0.3,
        cursor: disabled && !actionable ? 'not-allowed' : 'pointer', display: 'inline-flex', flexDirection: 'column', alignItems: 'center', gap: 2, lineHeight: 1.2,
        ...style,
      }}>
      <span>{actionable ? `${na.reason} →` : na.label}</span>
      {disabled && !actionable && size === 'lg' && <span style={{ fontSize: 11, fontWeight: 500, whiteSpace: 'normal' }}>{na.reason}</span>}
    </button>
  );
}
